<!-- <div class="UNFAPP-asmnt-full-area ILTSV3">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="UNFAPP-asmnt-tp-hdractn-area">
                    <div>
                        <button type="button" class="btn btn-outline-secondary desk-back-btn" (click)="goBack()"><img src="assets/img/back-arrow-icon-dark.svg" class="assessment_ml-0"> BACK</button>
                        <button type="button" class="btn mobile-back-btn" (click)="goBack()"><img src="assets/img/mob-back-arrow.png" class="assessment_ml-0"> Report</button>
                    </div>
                    <div></div>
                </div>

                <div class="ILTSV3-section">
                
                    <h3 class="ILTSV3-section-lg-hdng">{{testData?.rulename}} | {{testData?.timeFormat |date:'dd MMM YYYY'}}</h3>
                
                    <h3 class="ILTSV3-section-sm-hdng">Overview</h3>
                
                    <div class="ILTSV3-table-area">
                        <table class="ILTSV3-table">
                            <tr>
                                <th>Subjects</th>
                                <th>Attempted</th>
                                <th>Unattempted</th>
                                <th>Marked for review</th>
                            </tr>
                            <tr *ngFor="let subject of subject_overView">
                                <td>{{subject?.subjectName}}</td>
                                <td><b>{{subject?.totalAttemptedQuestions}}</b></td>
                                <td><b>{{subject?.totalUnAttemptedQuestions}}</b></td>
                                <td><b>{{subject?.totalMarkedFroReview}}</b></td>
                            </tr>
                        </table>
                    </div>
                
                
                    <div class="ILTSV3-white-bx">
                
                        <div class="ILTSV3-msg-section report-generated" *ngIf="!showReport">
                            <h3 class="ILTSV3-report-hdng">Generating Detailed Report!</h3>
                            <h4 class="ILTSV3-report-para-hdng">Appreciate your enthusiasm to check the report. Please wait till the
                                test finishes to see the detailed report</h4>
                            <img src="assets/img/animated-sand-watch.gif" class="ILTSV3-report-icn" />
                            <h4 class="ILTSV3-report-time">Your report will be generated in<br>
                                <b> {{timerFormat|async}}</b>
                            </h4>
                        </div>
                
                
                        <div class="ILTSV3-msg-section report-generated" *ngIf="showReport">
                            <h3 class="ILTSV3-report-hdng">Report Generated!</h3>
                            <img src="assets/img/animated-tick-icon.gif" class="ILTSV3-report-icn" />
                            <button class="btn UNFAPP-asmnt-blue-hdrbtn" [routerLink]="['/dashboard/viewtestreport']">View
                                Report</button>
                        </div>
                
                
                    </div>
                
                </div>
            </div>
        </div>
    </div>
</div> -->
<div class="UNFAPP-asmnt-full-area ILTSV3">
    <div class="container">
        <div class="col-12">
            <button routerLink="/dashboard/assessment" type="button" class="btn btn-outline-secondary assessment_mb-15 m-hide"><img class="assessment_ml-0 assessment_mr-2" src="assets/img/back-arrow-icon-dark.svg" alt="">BACK</button>
        
        </div>
        <div class=" heading-holder">
            <button routerLink="/dashboard/assessment"  type="button" class="m-btn-back m-show assessment_mb-25"><img src="assets/img/back-button.svg" alt="Back"></button>
            <h3 class="ILTSV3-section-lg-hdng">{{testData?.rulename}} | {{testData?.timeFormat |date:'dd MMM YYYY'}}</h3>
        </div>
            <div class="UNFAPP-subjctwise-box">
                <div class="UNFAPP-subjctwis-col lft-col">
                    <div class="UNFAPP-subjctwis-scr-avatr-sctn">
                        <img src="assets/img/{{testRecordData?.animationgifPercentage}}"
                            class="UNFAPP-subjctwis-scr-avatr-icn" />
                        <div class="UNFAPP-subjctwis-scr-avatr-ctn">
                            <h5 class="UNFAPP-subjctwis-scr-title">Your score is</h5>
                            <div class="UNFAPP-scr-big-font"><span
                                    class="UNFAPP-blue-text">{{testRecordData?.totalScore}}</span> /
                                {{testRecordData?.outOfScore}}</div>
                        </div>
                    </div>
                </div>
                <div class="UNFAPP-subjctwis-col rgt-col">
                    <h5 class="UNFAPP-subjctwis-scr-title score-title">Subjectwise score</h5>
                    <div class="UNFAPP-subjctwis-progrss-grp">
                        <ng-container *ngFor="let subject of subject_overView">
                            <div class="UNFAPP-subjctwis-progrss-row">
                                <h6 class="UNFAPP-subjctwis-progrss-title">{{subject?.subjectName}}</h6>

                       <div class="UNFAPP-subjctwis-progrss-wrap">
                                    <div class="UNFAPP-subjctwis-progrss-bar " [ngClass]="subject?.subjectClass"
                                        [ngStyle]="{'width.%':subject?.percentage||5}"><span
                                            *ngIf="subject?.totalScore < 0|| subject?.totalScore == 0"> {{subject?.totalScore}}</span> </div>
                                    <div class="UNFAPP-subjctwis-progrss-count"><span class=""
                                            [ngClass]="{'UNFAPP-red-text':(subject?.totalScore < 0),'UNFAPP-score-text':subject?.totalScore >=0}">
                                            {{subject?.totalScore}}</span><span> /
                                            {{subject?.outOfScore}}</span></div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="ILTSV3-white-bx">
                <div class="ILTSV3-msg-section report-generated" *ngIf="!showReport">
                    <img src="assets/img/animated-sand-watch.gif" class="ILTSV3-report-icn" />
                    <h4 class="ILTSV3-report-time">Check your Rank in the Report in</h4>
                    <button class="btn UNFAPP-asmnt-blue-hdrbtn btn-outline" >{{timerFormat|async}}</button>
                </div>
                <div class="ILTSV3-msg-section report-generated" *ngIf="showReport">
                    <img src="assets/img/animated-tick-icon.gif" class="ILTSV3-report-icn" />
                    <h4 class="ILTSV3-report-time">Check your Rank in the Report</h4>
                    <button class="btn UNFAPP-asmnt-blue-hdrbtn" [routerLink]="['/dashboard/viewtestreport']">View Report</button>
                </div>
            </div>
    </div>
</div>